import { IAction } from '@Root/types'

import {
  IWorkspaceUser,
  IWorkspaceUserData,
} from '@SiteModules/WorkspaceUser/types'

export const AccountUserActionTypes = {
  FETCH_ACCOUNT_USERS: '@@accountUser/FETCH_ACCOUNT_USERS',
  FETCH_ACCOUNT_USERS_SUCCESS: '@@accountUser/FETCH_ACCOUNT_USERS_SUCCESS',
  FETCH_ACCOUNT_USERS_FAILURE: '@@accountUser/FETCH_ACCOUNT_USERS_FAILURE',
  RESET_ACCOUNT_USERS: '@@accountUser/RESET_ACCOUNT_USERS',
  CREATE_ACCOUNT_USERS: '@@accountUser/CREATE_ACCOUNT_USERS',
  CREATE_ACCOUNT_USERS_SUCCESS: '@@accountUser/CREATE_ACCOUNT_USERS_SUCCESS',
  CREATE_ACCOUNT_USERS_FAILURE: '@@accountUser/CREATE_ACCOUNT_USERS_FAILURE',
  DELETE_ACCOUNT_USERS: '@@accountUser/DELETE_ACCOUNT_USERS',
  DELETE_ACCOUNT_USERS_SUCCESS: '@@accountUser/DELETE_ACCOUNT_USERS_SUCCESS',
  DELETE_ACCOUNT_USERS_FAILURE: '@@accountUser/DELETE_ACCOUNT_USERS_FAILURE',
  CHANGE_ROLE: '@@accountUser/CHANGE_ROLE',
  CHANGE_ROLE_SUCCESS: '@@accountUser/CHANGE_ROLE_SUCCESS',
  CHANGE_ROLE_FAILURE: '@@accountUser/CHANGE_ROLE_FAILURE',
  CHANGE_SELECTED_ACCOUNT_USERS: '@@accountUser/CHANGE_SELECTED_ACCOUNT_USERS',
  UNSELECT_ACCOUNT_USERS: '@@accountUser/UNSELECT_ACCOUNT_USERS',
  SELECT_ALL_ACCOUNT_USERS: '@@accountUser/SELECT_ALL_ACCOUNT_USERS',
}

export interface IAccountUserState {
  readonly accountUsers: IAccountUser[]
  readonly selectedAccountUserIds: number[]
  readonly hasLoadedInitially: boolean
  readonly loading: boolean
}

export interface IAccountUser {
  readonly id: number
  readonly attributes: IAccountUserAttributes
  readonly workspaceUsers: IWorkspaceUser[]
}

export interface IAccountUserData {
  readonly id: string
  readonly type: 'accountUser'
  readonly attributes: IAccountUserAttributes
  readonly relationships: IAccountUserRelationships
}

export interface IAccountUserAttributes {
  readonly role: string
  readonly createdAt: string
  readonly email: string
  readonly name: string
  readonly userId: number
  readonly avatarUrl: string
}

export interface IAccountUserRelationships {
  readonly workspaceUsers: {
    readonly data: IWorkspaceUserReference[]
  }
}

export interface IWorkspaceUserReference {
  readonly id: string
  readonly type: 'workspaceUser'
}

export interface IFetchAccountUsersPayload {
  readonly accountId: number
}

export interface IFetchAccountUsersSuccessResponseBody {
  readonly data: IAccountUserData[]
  readonly included: IWorkspaceUserData[]
}

export interface ICreateAccountUsersPayload {
  readonly accountId: number
  readonly emails: string[]
  readonly role: string
  readonly workspaceIds?: number[]
}

export interface IDeleteAccountUsersPayload {
  readonly accountUserIds: number[]
}

export type IDeleteAccountUsersSuccessPayload = IDeleteAccountUsersPayload

export interface IChangeRolePayload {
  readonly accountUserId: number
  readonly role: string
}

export interface IChangeSelectedAccountUsersPayload {
  readonly accountUserId: number
  readonly selectAccountUser: boolean
}

export type TAccountUserActionTypes =
  IAction<IFetchAccountUsersSuccessResponseBody> |
  IAction<IChangeSelectedAccountUsersPayload>
